@if (data) {
  <section class="taxi-time-container" id="{{ data.id }}">
    <div class="taxi-time-wrapper" [ngClass]="taxiTimeIndicatorClass">
      @if (!data.showLabelTop) {
        <div class="taxi-time-title" [ngClass]="{ 'domestic-error': data.domesticError }">
          {{ data.label }}
        </div>
      }
      <div
        class="taxi-time-value-wrapper"
        [ngClass]="{ 'taxi-time-value-wrapper-condensed': isCondensedMode }"
        [ngClass]="{ 'center-contents': data.internationalValue === 0 }"
        >
        <span
          class="taxi-time-domestic"
          [ngClass]="{ 'taxi-time-domestic-condensed': isCondensedMode }"
          [ngClass]="{ 'domestic-error': data.domesticError }"
          >
          {{ data.value | decodeHtmlString }}
        </span>
        @if (data.showInternational && data.internationalValue > 0) {
          <div
            class="taxi-time-international"
            [ngClass]="{ 'taxi-time-international-condensed': isCondensedMode }"
            [ngClass]="{ 'international-error': data.internationalError }"
            >
            <span class="taxi-time-international-label" [ngClass]="{ 'taxi-time-international-label-condensed': isCondensedMode }">INTL</span>
            <span
              class="taxi-time-international-value-wrapper"
              [ngClass]="{ 'taxi-time-international-value-wrapper-condensed': isCondensedMode }"
              >
              <span>({{ data.internationalValue | decodeHtmlString }})</span>
            </span>
            <span class="indicator" [ngClass]="internationalIndicatorClass"></span>
          </div>
        }
      </div>
    </div>
    @if (data.showLabelTop) {
      <div class="taxi-time-title-Y" [ngClass]="{ 'taxi-time-title-Y-condensed': isCondensedMode }">
        {{ data.label }}
      </div>
    }
    @if (!data.hideCheckBox) {
      <div class="checkbox-section">
        <input
          type="checkbox"
          name="chkTaxiTimes-{{ data.id }}"
          id="{{ data.id }}"
          [(ngModel)]="data.isChecked"
          (change)="onCheckboxChange($event)"
          />
      </div>
    }
  </section>
}
